import { render, staticRenderFns } from "./DateRangePickerForRules.vue?vue&type=template&id=0bcb2e6a"
import script from "./DateRangePickerForRules.vue?vue&type=script&lang=js"
export * from "./DateRangePickerForRules.vue?vue&type=script&lang=js"
import style0 from "./DateRangePickerForRules.vue?vue&type=style&index=0&id=0bcb2e6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports